import {
  AfterViewInit,
  Component,
  ElementRef,
  Renderer2,
  ViewChild,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { gsap } from 'gsap';
import { Footer } from "./footer/footer";
import { filter } from 'rxjs/operators';
import { WhatsappFloat } from './whatsapp-float/whatsapp-float';
 
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, Footer,WhatsappFloat],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements AfterViewInit, OnDestroy{
   @ViewChild('mobileMenu') mobileMenu!: ElementRef;
  @ViewChild('mobileButton') mobileButton!: ElementRef;
  @ViewChild('navbar') navbar!: ElementRef;

  menuOpen = false;
  private isBrowser: boolean;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,private cdr : ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

    

  ngAfterViewInit(): void {
    if (!this.isBrowser) return;

    gsap.fromTo(
      '.nav-item',
      { opacity: 0, y: -10 },
      { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, delay: 0.4 }
    );

    gsap.fromTo(
      '.cta-btn',
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 0.5, delay: 0.8 }
    );

    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach(item => {
      item.addEventListener('mouseenter', () =>
        gsap.to(item, { duration: 0.2, y: -2, ease: 'power2.out' })
      );
      item.addEventListener('mouseleave', () =>
        gsap.to(item, { duration: 0.2, y: 0, ease: 'power2.out' })
      );
    });

    const ctaBtn = document.querySelector('.cta-btn');
    if (ctaBtn) {
      ctaBtn.addEventListener('mouseenter', () =>
        gsap.to(ctaBtn, {
          duration: 0.3,
          boxShadow: '0 10px 25px rgba(115, 19, 70, 0.3)',
          ease: 'power2.out'
        })
      );
      ctaBtn.addEventListener('mouseleave', () =>
        gsap.to(ctaBtn, {
          duration: 0.3,
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          ease: 'power2.out'
        })
      );
    }
  }

  @HostListener('window:scroll', [])
  handleScroll(): void {
    if (!this.isBrowser) return;

    if (window.scrollY > 10) {
      this.renderer.addClass(this.navbar.nativeElement, 'bg-white/95');
      this.renderer.addClass(this.navbar.nativeElement, 'backdrop-blur-sm');
      gsap.to(this.navbar.nativeElement, {
        duration: 0.3,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      });
    } else {
      this.renderer.removeClass(this.navbar.nativeElement, 'bg-white/95');
      this.renderer.removeClass(this.navbar.nativeElement, 'backdrop-blur-sm');
      gsap.to(this.navbar.nativeElement, {
        duration: 0.3,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
      });
    }
  }

  toggleMobileMenu(): void {
    if (!this.isBrowser) return;

    this.menuOpen = !this.menuOpen;

    if (this.menuOpen) {
      this.renderer.addClass(this.mobileMenu.nativeElement, 'open');
      this.mobileButton.nativeElement.innerHTML =
        '<i class="fas fa-times text-4xl"></i>';

      gsap.fromTo(
        '.mobile-nav-item',
        { opacity: 0, x: -20 },
        { opacity: 1, x: 0, duration: 0.5, stagger: 0.1 }
      );
    } else {
      this.renderer.removeClass(this.mobileMenu.nativeElement, 'open');
      this.mobileButton.nativeElement.innerHTML =
        '<i class="fas fa-bars text-3xl"></i>';
    }
  }

  closeMobileMenu(): void {
    if (!this.isBrowser) return;

    this.menuOpen = false;
    this.renderer.removeClass(this.mobileMenu.nativeElement, 'open');
    this.mobileButton.nativeElement.innerHTML =
      '<i class="fas fa-bars text-xl"></i>';
  }

  navigateAndClose(route: string): void {
    this.router.navigate([route]);
    this.closeMobileMenu();
  }

  ngOnDestroy(): void {
    if (!this.isBrowser) return;
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }
}
